import { Ads } from "@shared";

type AssetArrayKey = "headlines" | "descriptions" | "callouts" | "keywords";

/**
 * Submit a refresh_assets intent. Rails is the authoritative source of asset
 * state — lock flags, text, and position are persisted via PATCH before this
 * fires, and the graph's loadAssets node hydrates from Rails on every refresh.
 * The frontend does not send asset arrays on refresh.
 */
export function createRefreshHandler<T extends AssetArrayKey>(
  assetName: T,
  assets: Ads.Asset[] | undefined,
  submit: (state: Record<string, unknown>) => void,
  stage: string
) {
  const numLocked = assets?.filter((a) => a.locked).length ?? 0;

  submit({
    intent: {
      type: "refresh_assets" as const,
      payload: {
        stage,
        assets: [
          {
            asset: assetName,
            nVariants: Ads.DefaultNumAssets[assetName] - numLocked,
          },
        ],
      },
      createdAt: new Date().toISOString(),
    },
  });
}
